<template>
  <Authenticated>
    <TrainingNav />
    <div class="content">
      <div class="section-header">
        <h3 class="section-title">Active Staff</h3>
        <button class="btn-add" @click="showAddModal = true">
          <font-awesome-icon icon="fa-plus" /> Add Staff
        </button>
      </div>
      <div v-if="activeStaff.length === 0" class="empty-state">No active staff found</div>
      <div v-for="staff in activeStaff" :key="staff.id" class="grid">
        <StaffComponent :staffMember="staff" />
      </div>

      <button @click="showInactiveStaff = !showInactiveStaff" class="toggle-inactive">
        {{ showInactiveStaff ? "Hide Inactive Staff" : "Show Inactive Staff" }}
      </button>
      <div v-if="showInactiveStaff" class="showInactiveStaff">
        <h3 class="section-title">Inactive Staff</h3>
        <div v-if="inactiveStaff.length === 0" class="empty-state">No inactive staff found</div>
        <div v-for="staff in inactiveStaff" :key="staff.id" class="grid inactive-grid">
          <StaffComponent :staffMember="staff" />
        </div>
      </div>
    </div>
    <UserDetailsModal
      :isOpen="showAddModal"
      :staff="newStaffTemplate"
      title="Add staff member"
      @close="showAddModal = false"
      @confirm="handleAddStaff"
    />
  </Authenticated>
</template>

<script>
import Authenticated from "../_layouts/Authenticated.vue";
import StaffComponent from "./StaffComponent.vue";
import TrainingNav from "./TrainingNav.vue";
import UserDetailsModal from "./UserDetailsModal.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TrainingDash",
  components: {
    Authenticated,
    StaffComponent,
    TrainingNav,
    UserDetailsModal,
  },
  data() {
    return {
      showInactiveStaff: false,
      showAddModal: false,
      newStaffTemplate: { value: { firstName: "", lastName: "", email: "", dob: "", mobile: "", startDate: "", manager: false, active: true, roles: [] } },
    };
  },

  computed: {
    ...mapGetters("training", ["getStaff", "getRoles", "getForms", "isLoaded"]),
    activeStaff() {
      return this.getStaff.filter((staff) => staff.value.active !== false);
    },
    inactiveStaff() {
      return this.getStaff.filter((staff) => staff.value.active === false);
    },
  },

  methods: {
    ...mapActions("training", ["addEmployee"]),
    async handleAddStaff(staffCopy) {
      await this.addEmployee(staffCopy.value);
      this.showAddModal = false;
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.header {
  margin: 0.5rem 1rem;
}

.content {
  background-color: var(--primary-colour);
  padding: 1rem;
  margin: 1rem;
  border-radius: 0.5rem;
  box-shadow: var(--box-shadow);

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 1rem 1rem 0.4rem;

    .section-title {
      margin: 0;
    }

    .btn-add {
      display: inline-flex;
      align-items: center;
      gap: 0.4rem;
      padding: 0.4rem 0.9rem;
      border: none;
      border-radius: 0.35rem;
      background-color: var(--action-colour);
      color: var(--primary-colour);
      font-size: 0.85rem;
      font-weight: 600;
      cursor: pointer;
      &:hover { opacity: 0.85; }
    }
  }

  .section-title {
    margin: 1rem 1rem 0.4rem;
    color: var(--text-colour);
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.02em;

    &.inactive {
      color: var(--warning-colour);
      margin-top: 1.25rem;
    }
  }

  .empty-state {
    margin: 0 1rem 0.5rem;
    font-size: 0.82rem;
    color: var(--text-colour);
    opacity: 0.65;
  }

  .grid {
    background-color: var(--secondary-colour);
    box-shadow: var(--box-shadow);
    border-left: solid 4px var(--action-colour);
    margin: 1rem;
    border-radius: 0.5rem;
    padding: 1rem;

    &.inactive-grid {
      border-left-color: #d43131;
    }
  }
}

.toggle-inactive {
  margin: 0 1rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  background-color: var(--secondary-colour);
  color: var(--action-colour);
  cursor: pointer;
}

.buttons {
  position: fixed;
  display: flex;
  bottom: 2rem;
  right: 1rem;
}
</style>
